module.exports = __webpack_public_path__ + "assets/img/bh2.4343714c.jpg";